// extracted by css-extract-rspack-plugin
export default {"withImage":"ContentfulCtaBanner-module__withImage__x2Lvt"};